@if ({ isMenuOpen: extraFooterMargin$ | async }; as model) {
  <footer class="container pt-5 pb-5 text-center" [ngClass]="{ 'margin-bottom35': model.isMenuOpen }">
    <p class="mb-1">&copy; Copyright {{ currentYear }} {{ brand.companyNameCopyright }}. All rights reserved.</p>
    <p class="mb-0">
      V{{ version }} |
      <a class="green-link" routerLink="/sitemap" data-cy="site-map">Site Map</a>
    </p>
  </footer>
}
